import { PACKAGE_ASPECT_RATIO } from "../const";
import * as Styled from "./style";
import { useRecommendItem } from "./use-recommend-item";
import { Carousel } from "~/components/blocks/common/carousel";
import { isGravureCategory } from "~/components/blocks/product/common/blocks/product-related-items/utils/is-gravure-category";
import type { G_VideoCategory, G_VideoContentType } from "~/lib/graphql";
import { ASPECT_RATIOS } from "~/styles/aspect-ratio";

type RecommendItemProps = {
  categories?: Pick<G_VideoCategory, "id">[];
  contentType?: G_VideoContentType;
};

/**
 * おすすめアイテムを表示するコンポーネント
 * - アイテム画像をクリックしたら、DMM.TVドメイン内の作品末端へ画面遷移させる
 */
export const RecommendItem = ({ categories, contentType }: RecommendItemProps) => {
  const { sectionRef, isLoading, carouselRecommendItems, displayItemCount } = useRecommendItem({
    categories,
    contentType,
  });

  const isGravure = isGravureCategory(categories);
  if (carouselRecommendItems.length === 0) return null;

  return (
    <section ref={sectionRef}>
      <Styled.Heading size="M">この作品を見た人はこの作品も見ています</Styled.Heading>

      <Carousel
        uniqueId="recommend-item-id"
        displayItemCount={displayItemCount}
        isDisabledPreviewModal
        items={carouselRecommendItems}
        skeletonSetting={{
          isShowSkeleton: isLoading,
          aspectRatio: isGravure ? ASPECT_RATIOS.GRAVURE_PORTRAIT : PACKAGE_ASPECT_RATIO,
        }}
      />
    </section>
  );
};
